// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__sVd3I","title":"Header_title__2rDMK","side":"Header_side__VezEA"};